import { getSystem, putSystem } from '@/api/system/set';
import CommonLayout, { CommonLayoutInstance } from '@/components/CommonLayout';
import { Button, Col, Form, Input, Row, Space, Switch, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import Upload from '@/components/Upload';
import useAuthButton from '@/hooks/useAuthButton';
import styles from './index.module.less';

const SysSet = () => {
  const { checkPermissionDisabled } = useAuthButton();
  const CommonLayoutRef = useRef<CommonLayoutInstance<{ params: {}; model: {}; drawerParams: {}; drawerModel: {} }>>(null);
  const [showFlow, setShowFlow] = useState(true);
  const [showTime, setShowTime] = useState(true);

  // 加载系统配置获取开关状态
  useEffect(() => {
    getSystem({}).then((res: any) => {
      if (res?.result?.show_flow !== undefined) setShowFlow(res.result.show_flow);
      if (res?.result?.show_time !== undefined) setShowTime(res.result.show_time);
    }).catch(() => {});
  }, []);

  // 开关变化时立即保存到后端
  const saveToggle = async (field: string, value: boolean) => {
    try {
      // 先获取当前完整配置
      const current = await getSystem({});
      if (!current?.result) return;
      const data: any = { ...current.result };
      delete data.version;
      delete data.amap;
      data[field] = value;
      const resp = await putSystem(data);
      if ((resp as any)?.success) {
        message.success(field === 'show_flow' ? '累计流量开关已更新' : '剩余时长开关已更新');
        window.localStorage.removeItem('$systemData$');
      }
    } catch (e) {
      message.error('保存失败');
      // 恢复开关状态
      if (field === 'show_flow') setShowFlow(!value);
      else setShowTime(!value);
    }
  };

  return (
    <CommonLayout
      ref={CommonLayoutRef}
      breadcrumb={{
        title: '系统配置',
        describe: '系统设置页面提供系统基础配置项，支持用户对系统的名称、登录页、LOGO等基础信息进行维护管理。',
      }}
      mainType="form"
      ajaxJson={{
        get: {
          // @ts-ignore
          ajax: getSystem,
        },
        update: {
          // @ts-ignore
          ajax: putSystem,
          operateName: '保存',
          successMsgText: '保存成功，即将刷新页面',
          cbk: () => {
            window.localStorage.removeItem('$systemData$');
            setTimeout(() => window.location.reload(), 500);
          },
        },
      }}
      mainFormChildren={
        <>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="小程序显示累计流量" extra="关闭后小程序端累计流量显示为—，不可交互">
                <Switch checkedChildren="显示" unCheckedChildren="隐藏" checked={showFlow}
                  onChange={(checked) => { setShowFlow(checked); saveToggle('show_flow', checked); }} />
              </Form.Item>
              <Form.Item label="小程序显示剩余时长" extra="关闭后小程序端剩余时长显示为—，不可交互">
                <Switch checkedChildren="显示" unCheckedChildren="隐藏" checked={showTime}
                  onChange={(checked) => { setShowTime(checked); saveToggle('show_time', checked); }} />
              </Form.Item>
              <Form.Item label="系统名称" name="system_name" rules={[{ required: true, message: '请输入系统名称' }]}>
                <Input placeholder="请输入" disabled={checkPermissionDisabled('admin:sysSet:update')}></Input>
              </Form.Item>
              <Form.Item label="copyright" name="copyright" rules={[{ required: true, message: '请输入copyright' }]}>
                <Input placeholder="请输入" disabled={checkPermissionDisabled('admin:sysSet:update')}></Input>
              </Form.Item>
              <Row>
                <Col span={12}>
                  <Form.Item label="系统logo" name="system_logo_file" rules={[{ required: true, message: '请选择系统logo' }]}>
                    <Upload className={styles['left-upload']} showMessage="推荐尺寸200*200" maxCount={1} disabled={checkPermissionDisabled('admin:sysSet:update')}></Upload>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="浏览器标签" name="system_browser_label" rules={[{ required: true, message: '请选择浏览器标签' }]}>
                    <Upload className={styles['left-upload']} maxCount={1} showMessage="推荐尺寸：64*64" disabled={checkPermissionDisabled('admin:sysSet:update')}></Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Form.Item label="背景图" name="system_background_image" rules={[{ required: true, message: '请选择背景图' }]}>
                <Upload className={styles['right-upload']} maxCount={1} showMessage="推荐尺寸：800*600" disabled={checkPermissionDisabled('admin:sysSet:update')}></Upload>
              </Form.Item>
            </Col>
          </Row>
          {!checkPermissionDisabled('admin:sysSet:update') && (
            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit" loading={!!CommonLayoutRef.current?.loading}>保存</Button>
              </Space>
            </Form.Item>
          )}
        </>
      }
    ></CommonLayout>
  );
};

export default SysSet;
